import React from "react";
import { Conocenos } from "./Components/Conocenos/Conocenos";
import { Contacto } from "./Components/Contacto/Contacto";
import { Footer } from "./Components/Footer/Footer";
import { Navbar } from "./Components/Navbar/Navbar";
import { Servicios } from "./Components/Servicios/Servicios";

import { Campaign } from "./Components/Slider/Slides/Campaign";
import { Submarcas } from "./Components/Submarcas/Submarcas";

export const Home = () => {
  return (
    <div>
      <Navbar />
      <Campaign />
      <Conocenos id="conocenos" />
      <Servicios></Servicios>
      <Submarcas></Submarcas>
      <Contacto></Contacto>
      <Footer></Footer>
    </div>
  );
};
